/* Types */
import { Position } from 'geojson'
import { AreaProperties, LatLng } from '@/api/modules/delivery/types'

/**
 * Рассчет вхождения координат адреса в полигон
 * Теория формулы: https://caxapa.ru/751493.html?todo=full
 * @param polygon
 * @param point
 */
const checkAddressInDeliveryArea = (polygon: Position[], point: LatLng) => {
  const x = point[1]
  const y = point[0]

  let isInside = false

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0]
    const yi = polygon[i][1]
    const xj = polygon[j][0]
    const yj = polygon[j][1]

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi

    if (intersect) isInside = !isInside
  }

  return isInside
}

/**
 * Поиск данных о полигоне путем вхождения координат адреса в полигоны зон доставки
 * @param polygons - зоны доставки
 * @param coords - координаты адреса
 */
export const findOfDeliveryArea = (
  polygons: AreaProperties[],
  coords: LatLng,
) => {
  for (const polygon of polygons) {
    if (checkAddressInDeliveryArea(polygon.polygon[0], coords)) return polygon
  }
}
